import { operationLog } from '@home/services/home';
import { typeIdObj } from '@home/utils/buriedPoint';

import type { pointInter, btnPointInter } from '@home/utils/buriedPoint';

interface searchInter {
  typeId: string;
  extInfo?: string;
}

/**
 * 详情页打点key配置
 */
export interface IDetailsPagePointConfig {
  /**
   * id体系（即id的类型，比如游戏id、公司id、project id）
   */
  uidType: string;
  /**
   * id
   */
  uid: string;
}

/**
 * 页面打点配置
 */
type IPagePointConfig = pointInter & (IDetailsPagePointConfig | IOptional<IDetailsPagePointConfig>);

/**
 * 按钮打点配置 - supports object extInfo (will be stringified)
 */
type IButtonPointConfig = (btnPointInter & (IDetailsPagePointConfig | IOptional<IDetailsPagePointConfig>)) & {
  extInfo?: Record<string, any> | string;
};

/**
 * 搜索打点配置
 */
type ISearchPointConfig = searchInter & (IDetailsPagePointConfig | IOptional<IDetailsPagePointConfig>);

/**
 * 页面打点
 * @param params 页面打点配置
 */
export const reportPageLog = (params: IPagePointConfig) => {
  const {
    typeId = typeIdObj.intelligence,
    pageId = '',
    pageName = '',
    pagePath = '',
    uidType,
    uid,
    extInfo,
  } = params || {};

  const pointParams = {
    logType: 'pageLog',
    openId: '',
    pageLog: {
      source: 0,
      typeId,
      pageId,
      pageName,
      pagePath,
      uidType,
      uid,
      isOnline: 'logIn',
      extInfo,
    },
  };

  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(pointParams)
    .then(() => {})
    .catch((e) => {
      console.log(e);
    });
};

/**
 * 按钮打点
 * @param params 按钮打点配置
 */
export const reportButtonLog = (params: IButtonPointConfig) => {
  const { typeId = typeIdObj.intelligence, pageId, buttonId, buttonName, uidType, uid, gameName, extInfo } = params;

  // Process extInfo - if it's an object, stringify it
  let processedExtInfo: string;
  if (typeof extInfo === 'object' && extInfo !== null) {
    processedExtInfo = JSON.stringify(extInfo);
  } else {
    processedExtInfo = extInfo || '';
  }

  const logParams = {
    logType: 'buttonLog',
    openId: '',
    buttonLog: {
      source: 1,
      typeId,
      pageId,
      buttonId,
      buttonName,
      uidType,
      uid,
      gameName,
      extInfo: processedExtInfo,
    },
  };

  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(logParams)
    .then(() => {})
    .catch((e) => {
      console.log(e);
    });
};

/**
 * 搜索打点
 * @param params 搜索打点配置
 * @param dynamicParams 动态搜索参数配置
 */
export const reportSearchLog = (
  params: ISearchPointConfig & { pageId: string },
  dynamicParams: { query: string; clickId: string; extInfo?: string } & (
    | IDetailsPagePointConfig
    | IOptional<IDetailsPagePointConfig>
  ),
) => {
  const { typeId = typeIdObj.intelligence, pageId } = params || {};
  const { query = '', clickId = '', uidType, uid, extInfo = '' } = dynamicParams || {};

  const logParams = {
    logType: 'searchLog',
    openId: '',
    searchLog: {
      typeId,
      source: 1,
      pageId,
      query,
      clickId,
      uidType,
      uid,
      extInfo,
    },
  };

  // 这样写可以防止日志报错，用try catch的话还是会报错
  operationLog(logParams)
    .then(() => {})
    .catch((e) => {
      console.log(e);
    });
};
